import { Component, Input } from '@angular/core';
import { NgStyle, SlicePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-expandable-tags',
	templateUrl: './au-expandable-tags.component.html',
	styleUrls: ['./au-expandable-tags.component.scss'],
	imports: [NgStyle, MatTooltip, SlicePipe, NgxTolgeeModule],
})
export class AuExpandableTagsComponent {
	@Input() tags: any[];
	@Input() initSize = 5;
	@Input() minWidth = `200px`;
	@Input() textMaxWidth = '';
	tagsCollapsed = true;

	toggleTags() {
		this.tagsCollapsed = !this.tagsCollapsed;
	}
}
